import React, { useRef, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function FileUpload({ accept, value, onChange, preview = false, testid }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url, file.name);
      toast.success("Uploaded");
    } catch {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={handle} data-testid={testid ? `${testid}-input` : "file-input"} />
      <div className="flex items-center gap-3">
        <Button type="button" variant="outline" size="sm" onClick={() => ref.current?.click()} disabled={busy} data-testid={testid || "file-upload-btn"}>
          {busy ? <Loader2 size={14} className="mr-1 animate-spin" /> : <Upload size={14} className="mr-1" />} {busy ? "Uploading..." : "Upload File"}
        </Button>
        {value && <span className="text-xs text-emerald-600">Uploaded ✓</span>}
      </div>
      {preview && value && <img src={fileUrl(value)} alt="preview" className="mt-2 h-20 rounded border border-border object-cover" />}
    </div>
  );
}
